export default "__VITE_ASSET__6342b82c__"